import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import { WorkspaceDataplane } from "src/clients/flow-api";
import { ServiceInfraMetadata } from "src/clients/router";
import { getInfoEndpoint } from "src/powertools/utils";

const wsInfoKey = (id: string) => ["wsinfo", id] as const;

export const useWsInfo = (workspace: WorkspaceDataplane) => {
  return useQuery<ServiceInfraMetadata, Error>({
    queryKey: wsInfoKey(workspace.id),
    queryFn: async () =>
      (
        await axios.get(getInfoEndpoint(workspace), {
          params: { include_cfn_last_updated: true },
        })
      ).data as ServiceInfraMetadata,
  });
};
